import React from 'react';
import styled from 'styled-components';

import { SusnetImage } from '~/components/_wrapper/SusnetImage';
import { Futura } from '~/styles';
import { media } from '~/utils';

export default function ({ org, onClick, large = false }) {
  return (
    <Wrapper large={large}>
      <Top>
        {/* <Cover src={org.cover} /> */}
        <SusnetImage src={org.cover} alt={org.ownerTitle} fill sizes='100vw' />
        <TopTitle>メッセージ</TopTitle>
      </Top>
      <Owner>
        <OwnerTitle>{org.ownerTitle}</OwnerTitle>
        <OwnerName>{org.owner}</OwnerName>
        <OwnerImage src={org.ownerImage} />
      </Owner>
      <MessageTitle>{org.messageTitle}</MessageTitle>
      <MessageText large={large}>{org.messageText}</MessageText>
      {!large && <SeeMore onClick={onClick}>SEE MORE</SeeMore>}
    </Wrapper>
  );
}

const Wrapper = styled.div`
  background: #fff;
  border-radius: 10px;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  position: relative;

  ${media.mid`
    border-radius: 0;
  `}

  ${(props) =>
    props.large &&
    `
    height: auto;
    padding-bottom: 40px;
  `}
`;

const Top = styled.div`
  aspect-ratio: 16 / 9;
  position: relative;
  width: 100%;

  img {
    aspect-ratio: 16 / 9;
    object-fit: cover;
  }
`;

const TopTitle = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 87px;
  height: 30px;
  text-align: center;
  background: rgba(255, 255, 255, 0.5);
  backdrop-filter: blur(2px);
  color: #2c2c2c;
  font-size: 12px;
  font-weight: bold;
  line-height: 30px;
`;

const Owner = styled.div`
  padding: 10px 35px 0;
  position: relative;
`;

const OwnerTitle = styled.div`
  color: #505050;
  font-size: 12px;
`;

const OwnerName = styled.div`
  margin-top: 5px;
  color: #2c2c2c;
  font-size: 18px;
  font-weight: bold;
`;

const OwnerImage = styled.img`
  width: 120px;
  height: 120px;
  border-radius: 60px;
  position: absolute;
  right: 35px;;
  bottom 0;
`;

const MessageTitle = styled.div`
  padding: 0 35px;
  font-size: 30px;
  line-height: 40px;
  font-weight: bold;
  color: #070707;
  white-space: pre-wrap;
`;

const MessageText = styled.div`
  padding: 20px 35px 0;
  color: #505050;
  font-size: 18px;
  line-height: 32px;
  letter-spacing: 1px;
  text-align: justify;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3;
  overflow: hidden;
  margin-bottom: 60px;

  ${(props) =>
    props.large &&
    `
    white-space: pre-wrap;
    overflow: initial;
  `}
`;

const SeeMore = styled(Futura)`
  position: absolute;
  font-size: 15px;
  text-decoration: underline;
  display: block;
  cursor: pointer;
  z-index: 1;
  left: 35px;
  bottom: 10px;
`;
